import ErrorComponent from '../../../components/Error';
import NewsCard from '../../../components/News/NewsCard';
import Carousel from '../../Carousel';

import { useApi } from '../../../utils/hooks';

function NewsCarousel() {
    const { data, loading, error } = useApi('news/');

    // Display the error message if the request fails
    if (loading) return <div className="container">Chargement...</div>;

    // Display a loading message while the request is pending
    if (error) return <ErrorComponent title="Error" errorObject={error} />;

    // Keep the last news from the DB
    const lastNews = data.results?.slice(0, 5);

    // Prepare items for the carousel
    const carouselItems = lastNews.map((item) => ({
        id: item.id,
        content: (
            <NewsCard
                id={item.id}
                title={item.title}
                date={item.timestamp}
                author={item.author}
                img={item.img}
            />
        ),
    }));

    return <Carousel items={carouselItems} loop={lastNews.length > 3} />;
}

export default NewsCarousel;
